import { createHeaders, request, withTimeout } from '../../services/request'

export async function getCurrentUser() {
  const headers = await createHeaders()
  const response = await fetch(new Request('/api/me', { method: 'get', headers }))

  if (!response.ok) {
    // this is an http code 40x or 50x
    throw new Error(response.statusText)
  }

  return await response.json()
}

export async function postLogin(username: string, password: string) {
  const path = '/auth/access_token'
  const formData = new FormData()
  formData.append('username', username)
  formData.append('password', password)
  formData.append('grant_type', 'password')

  // NOTE: Only need to supply these .env vars in development mode.
  // The proxy adds them securely in production
  formData.append('client_id', String(process.env.REACT_APP_PT_CLIENT_ID))
  formData.append('client_secret', String(process.env.REACT_APP_PT_CLIENT_SECRET))

  const args: RequestInit =  { method: 'post', body: formData}
  const response = await fetch(new Request('/api' + path, args))

  if (!response.ok) {
    // this is an http code 40x or 50x
    throw new Error(response.statusText)
  }

  return await response.json()
}

export async function logout()  {
  const path = '/auth/access_token'
  const headers = await createHeaders()
  const args: RequestInit =  { method: 'delete', headers }

  try {
    const timeoutMs = 25000

    const response = await (withTimeout(timeoutMs, fetch(new Request('/api' + path, args))))

    if (!response.ok) {
      // this is an http code 40x or 50x
      throw new Error(response.statusText)
    }
  } catch {
    // This occurs running locally as the proxy does not handle the logout redirect.
  }

  return
}

export async function getPartners() {
  const response = await request({
    path: '/resellers',
    method: 'get'
  })

  return response
}

